<script>
import abstractField from '../abstractField';
import { h } from 'vue';

export default {
  name: 'field-custom',
  mixins: [abstractField],
  render() {
    return h(
      'div',
      {
        class: `field-custom-item ${this.schema.fieldClasses}`,
        id: this.schema.id
      },
      [this.$slots.default && this.$slots.default()]
    );
  }
};
</script>

<style lang="scss" scoped>
.field-custom-item {
  width: 100%;

  .c-clipboard,
  .lego-radio-wrapper {
    padding-top: 6px;
  }

  .lego-radio-wrapper {
    &[style='display: none;'] {
      + .c-form--inner {
        margin-top: 8px;
      }
    }

    + .c-form--inner {
      margin-top: 16px;
    }
  }

  .c-form--inner__button {
    margin-bottom: 16px;
  }

  .custom-label {
    padding-top: 6px;

    &.margin-footer {
      margin-bottom: 16px;
    }
  }
}
</style>
